export const FromToDateRangeMonth = (duration: number) => {
  return (value: { fromDate: Date | null; toDate: Date | null }) => {
    const time_diff = value.toDate && value.fromDate ? value.toDate.getTime() - value.fromDate.getTime() : duration + 1
    return duration < time_diff / (1000 * 3600 * 24 * 30) ? { isInvalidRange: true } : null
  }
}

export const InvalidStreet = (text: string): boolean => {
  return /[");']/.test(text) || /-{2}/.test(text) || /Xp_/.test(text) || /\/\*.+\*\//.test(text)
}